// extracted by mini-css-extract-plugin
module.exports = {"root":"quantity_root__T73tE","input":"quantity_input__807jP"};